export const properties = {
    instagramUrl: "https://www.instagram.com/saga.cityband",
    facebookUrl: "https://www.facebook.com/profile.php?id=61566868440580",
    emailUrl: "mailto:hi@sagacity.au?subject=hi from website",
    gigListUrl: "https://api.npoint.io/a4aa14488de9cc3a30ab"
};